import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function FailedMethodsSection() {
  const failedMethods = [{
    title: 'Pull-Ups = diapers',
    description: 'Different label, same comfort, same confusion.'
  }, {
    title: '"Slow and steady" creates mixed signals',
    description: '(underwear... then diaper... then underwear again).'
  }, {
    title: 'Asking "Do you need to go?"',
    description: "Doesn't work because kids will choose play every time."
  }, {
    title: 'The fear of accidents makes you backtrack',
    description: 'And backtracking erases progress.'
  }, {
    title: 'No real plan',
    description: 'Most parents never had a real step-by-step plan for Monday morning at daycare.'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      x: -20
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="py-20 px-4 bg-white" data-id="element-1">
      <div className="max-w-4xl mx-auto" data-id="element-2">
        <div className="text-center mb-12" data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-4">
            Why What You've Tried Hasn't Worked
          </h2>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid gap-4 md:gap-6" data-id="element-5">
          {failedMethods.map((method, index) => <motion.div key={index} variants={itemVariants} className="flex items-start gap-4 p-5 md:p-6 rounded-xl bg-accent/30 border border-border hover:bg-accent/50 transition-colors" data-id="element-6">
              <XCircle className="w-6 h-6 text-destructive flex-shrink-0 mt-0.5" data-id="element-7" />
              <div data-id="element-8">
                <h3 className="text-lg font-semibold text-foreground mb-1" data-id="element-9">
                  {method.title}
                </h3>
                <p className="text-foreground/70" data-id="element-10">{method.description}</p>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}